<template>
  <div class="search-results">
    <div class="item my-5" v-for="(item, index) in items" :key="index">
      <product-item :item="item" />
    </div>
  </div>
</template>
<script>
import ProductItem from "@/components/marketplace/ProductItem";
export default {
  components: {
    ProductItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
.search-results {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 265px);
  justify-content: space-between;
  grid-gap: 10px;

  .item {
    min-height: 400px;
    min-width: 265px;
  }

  @media screen and (max-width: 768px) {
    justify-content: center;
    grid-template-columns: repeat(auto-fill, 100%);
    .item {
      min-width: 100%;
    }
  }
}
</style>
